import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as ProfilePic } from "../../assets/profile-pic.svg";
import { ReactComponent as CloseProgress } from "../../assets/close-progress.svg";
import { setNotifTo } from "../../store";
import classNames from "classnames";
import { useEffect } from "react";

function Notification() {
  const dispatch = useDispatch();
  const { notifText } = useSelector((state) => state.app);

  useEffect(() => {
    notifText &&
      setTimeout(() => {
        notifText && dispatch(setNotifTo(null));
      }, 6000);
  }, [dispatch, notifText]);

  if (!notifText) return null;

  return (
    <div
      className={classNames(
        "fixed left-0 right-0 mx-auto mt-2 w-2/5 notif-banner transition-transform rounded overflow-hidden flex flex-col z-50"
      )}
    >
      <div className="h-9 w-full bg-black flex flex-row items-center px-1">
        <ProfilePic />
        <span className="grow notif-name pl-2">Rohan</span>
        <div className="h-full aspect-square relative">
          <CloseProgress
            className="absolute top-0 left-0 right-0 bottom-0 m-auto cursor-pointer"
            onClick={() => {
              dispatch(setNotifTo(null));
            }}
          />
        </div>
      </div>
      <div className="notif-text rounded-b">{notifText}</div>
    </div>
  );
}

export default Notification;
